// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DetailedFeedback__wrapper-e778e8 {
  padding: 24px;
}

.DetailedFeedback__sub-title-f8c575 {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  margin-bottom: 16px;
  color: var(--base-110);
}

.DetailedFeedback__issues-tabs-container-c84ece {
  display: flex;
  margin-bottom: 32px;
}

.DetailedFeedback__button-ad6c2f {
  display: flex;
  margin: auto 24px 16px auto;
}

.DetailedFeedback__input-cce180 label {
  height: auto;
  max-height: 100px;
}

.DetailedFeedback__input-cce180 textarea {
  box-sizing: border-box;
  flex: 1 1 auto;
  min-height: 26px;
  overflow: auto;
}

.DetailedFeedback__problems-types-container-ad9dd5 {
  margin-bottom: 32px;
}`, "",{"version":3,"sources":["webpack://./src/main/Popups/DetailedFeedback/DetailedFeedback.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,2BAAA;AACF;;AAEA;EACE,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;AACF","sourcesContent":[".wrapper {\n  padding: 24px;\n}\n\n.sub-title {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  margin-bottom: 16px;\n  color: var(--base-110);\n}\n\n.issues-tabs-container {\n  display: flex;\n  margin-bottom: 32px;\n}\n\n.button {\n  display: flex;\n  margin: auto 24px 16px auto;\n}\n\n.input label {\n  height: auto;\n  max-height: 100px;\n}\n\n.input textarea {\n  box-sizing: border-box;\n  flex: 1 1 auto;\n  min-height: 26px;\n  overflow: auto;\n}\n\n.problems-types-container {\n  margin-bottom: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `DetailedFeedback__wrapper-e778e8`,
	"sub-title": `DetailedFeedback__sub-title-f8c575`,
	"subTitle": `DetailedFeedback__sub-title-f8c575`,
	"issues-tabs-container": `DetailedFeedback__issues-tabs-container-c84ece`,
	"issuesTabsContainer": `DetailedFeedback__issues-tabs-container-c84ece`,
	"button": `DetailedFeedback__button-ad6c2f`,
	"input": `DetailedFeedback__input-cce180`,
	"problems-types-container": `DetailedFeedback__problems-types-container-ad9dd5`,
	"problemsTypesContainer": `DetailedFeedback__problems-types-container-ad9dd5`
};
module.exports = ___CSS_LOADER_EXPORT___;
